import { useMemo } from "react"

/**
 * Returns a reference that only changes when the array's contents change.
 *
 * Streaming answer updates rebuild arrays such as `assistant_files` (or fall
 * back to a fresh `[]`) on every tick. Fed into memo dependencies, that churn
 * gives ReactMarkdown renderer functions new identities and remounts their
 * subtrees (#3485).
 */
export function useStableStringArray(values: readonly string[]): string[] {
  const key = JSON.stringify(values)
  return useMemo(() => JSON.parse(key) as string[], [key])
}
